// --- Our Modules --------------------------------------------------------------------------------
import "./styles.css";
// --- Logic --------------------------------------------------------------------------------------
export type TyScope = "all" | "mine";

type Props = { value: TyScope; onChange: (value: TyScope) => void; allLabel: string; mineLabel: string };

/**
 * Everything, or only what is mine — the one filter a sales agent sets every single morning.
 *
 * It sits outside the filter panel on purpose. A filter you open a panel for, set, and apply is
 * right for a question asked once a week; this one is asked on arrival, and burying it behind two
 * presses is what makes people stop using it. It is still a filter, so it still travels in the URL
 * with the rest.
 */
export default function ScopeTabs({ value, onChange, allLabel, mineLabel }: Props) {
    return (
        <nav className="scope-tabs" role="group">
            <button
                type="button"
                className={`scope-tabs__tab${value === "all" ? " scope-tabs__tab--on" : ""}`}
                onClick={() => onChange("all")}
                aria-pressed={value === "all"}
            >
                {allLabel}
            </button>
            <button
                type="button"
                className={`scope-tabs__tab${value === "mine" ? " scope-tabs__tab--on" : ""}`}
                onClick={() => onChange("mine")}
                aria-pressed={value === "mine"}
            >
                {mineLabel}
            </button>
        </nav>
    );
}
